"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _DurationsOverTimeStyles = require("web/shared/telemetry/charts/DurationsOverTime.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The points of the durations chart, rendered once and not again while the
* cursor moves.
*
* Memoized on the data alone, deliberately excluding which point is hovered.
* A window can hold hundreds of measurements, and re-rendering every one of
* them on every mouse move would make this chart crawl — the highlight and
* the popover are one small overlay above this layer instead.
*/
const ScatterPoints = /*#__PURE__*/React.memo(function ScatterPoints(_ref) {
  let points = _ref.points,
    firstMs = _ref.firstMs,
    spanMs = _ref.spanMs,
    slowest = _ref.slowest;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: points.map((point, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_DurationsOverTimeStyles.styles.scatterPoint)), {}, {
      style: {
        left: spanMs > 0 ? "".concat((point.startedAtMs - firstMs) / spanMs * 100, "%") : "50%",
        bottom: slowest > 0 ? "".concat(point.durationMs / slowest * 100, "%") : "0%"
      }
    }), "".concat(point.startedAtMs, "-").concat(index)))
  });
});
var _default = exports.default = ScatterPoints;